import { REVIEW_THEME_NAME_LABELS, type ReviewTheme, ReviewThemeSchema } from "@domains/reviews/shared/reviewThemes.ts";
import type { LanguageKey } from "@packages/core/language/language.ts";

interface ReviewThemeCopy {
    name: string;
    description: string;
}

export function buildReviewThemesNamespace(language: LanguageKey, descriptions: Record<ReviewTheme, string>) {
    return Object.fromEntries(ReviewThemeSchema.options.map(theme => [theme, { name: REVIEW_THEME_NAME_LABELS[theme][language], description: descriptions[theme] }])) as Record<ReviewTheme, ReviewThemeCopy>;
}
